export type ResendConfirmationEmailErrorCode = 'NOT_FOUND' | 'UNKNOWN';

export class ResendConfirmationEmailError extends Error {
    code: ResendConfirmationEmailErrorCode;

    constructor(code: ResendConfirmationEmailErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
